import { Button, Grid, makeStyles } from '@material-ui/core';
import React, { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { FORM } from '../../../constants/props';
import Input from '../../common/input';
import _ from 'lodash';

const useStyles = makeStyles((theme) => ({
  left: {
    [theme.breakpoints.up('sm')]: {
      marginRight: '1.25rem',
    },
  },
  button: {
    marginTop: '2.875rem',
  },
}));

const DeleteForm = ({ disabled, onSubmit, onCancel }) => {
  const classes = useStyles();
  const { control, handleSubmit, getValues } = useForm({});
  const [confirmation, setConfirmation] = useState("");

  const handleChange = (onChange) => (e) => {
    setConfirmation(e.target.value);
    onChange(e);
  }

  return (
    <form>
      <Grid container justify="center">
        <Grid item xs={6}>
          <Controller
            control={control}
            name="confirmation"
            defaultValue={confirmation}
            render={({ onChange, value }) => (
              <Input
                value={value}
                placeholder=""
                resize="none"
                onChange={handleChange(onChange)}
              />
            )}
          />
        </Grid>
      </Grid>
      <Grid container justify="center" direction="row" spacing={3}>
        <Grid item>
          <Button
            disabled={disabled}
            className={classes.button}
            variant="outlined" color="primary"
            onClick={onCancel}
          >
            Cancel
          </Button>
        </Grid>
        <Grid item>
          <Button
            disabled={disabled || _.trim(getValues("confirmation")) !== "DELETE"}
            className={classes.button}
            variant="contained"
            color="primary"
            onClick={handleSubmit(onSubmit)}
          >
            Delete
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

DeleteForm.defaultValue = {
  disabled: false,
};

DeleteForm.propTypes = {
  FORM,
};

export default DeleteForm;
